/**
 * return Api Settings
 * @param params
 */
const getApiSettingsHelper = (params: URLSearchParams) => {
    const settings = {
        method: 'POST',
        headers:  {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params,
    };

    return settings;
};

export default getApiSettingsHelper;
